<script>
    export let image;
    export let altTag;
    export let totalSlides;
    export let slideNo;
    export let imageShowing;
</script>

<style>
    

    .numbertext{
        color: #f2f2f2;
        font-size: 12px;
        padding: 8px 12px;
        position: absolute;
        top: 0;
    }

    img {
        min-width: 700px;
        max-width: 700px;
        min-height: 450px;
        max-height: 450px;
        object-fit: cover;
    }

    
</style>

<div class="mySlides" class:show={imageShowing}>
    <div class="numbertext">{slideNo} / {totalSlides}</div>
    <img src={image} alt={altTag}>
</div>